export enum AccountTypes {
  Guardian = 'GUARDIAN',
  Org = 'ORGANISATION',
  Clinic = 'CLINIC',
}
